import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import SignInView from '../views/SignInView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{
      authRequired: true
    }
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignInView,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
